import { render } from "./logsList.vue?vue&type=template&id=040afada&scoped=true"
import script from "./logsList.vue?vue&type=script&lang=js"
export * from "./logsList.vue?vue&type=script&lang=js"

import "./logsList.vue?vue&type=style&index=0&id=040afada&lang=scss&scoped=true"
import "./logsList.vue?vue&type=style&index=1&id=040afada&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040afada"]])

export default __exports__